import { render, staticRenderFns } from "./MobileBonusPage.vue?vue&type=template&id=0f2ce904&scoped=true&"
import script from "./MobileBonusPage.vue?vue&type=script&lang=js&"
export * from "./MobileBonusPage.vue?vue&type=script&lang=js&"
import style0 from "./MobileBonusPage.vue?vue&type=style&index=0&id=0f2ce904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ce904",
  null
  
)

export default component.exports